<template>
    <div class="series-container">
        <div class="carousel-container">
            <div class="tip">
                <p class="tip" v-if="series.tip.tip">
                    <small>{{series.tip.tip}}</small>
                </p>
                <h3 v-if="series.tip.caption">{{series.tip.caption}}</h3>
                <p class="text" v-if="series.tip.text">{{series.tip.text}}</p>
                <a :href="series.tip.btn.to" onclick="return false">
                    <b-button class="btn light" v-if="series.tip.btn" @click="redirect(series.tip.btn.to)">
                        {{series.tip.btn.text}}
                    </b-button>
                </a>
            </div>
            <Carousel :slides="series.slides"></Carousel>
        </div>
        <ProductList  class="product-list" :productList="series.products"></ProductList>
    </div>
</template>

<script>
    import Carousel from '../../common/Carousel'
    import ProductList from '../../common/ProductList'

    export default {
        name: 'series',
        props: {
            series: Object,
        },
        components: {
            Carousel,
            ProductList,
        },
        methods: {
            redirect(path) {
                this.$router.push({
                    path
                })

                document.scrollingElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../../assets/style/var";

    .en {
        .carousel-container {
            h3 {
                font-size: 28px !important;
                line-height: 38px !important;
                margin-bottom: 16px !important;
                font-family: Montserrat-SemiBold, Helvetica, Arial, sans-serif !important;
            }

            .text {
                font-size: 14px !important;
            }
        }
    }

    .carousel-container {
        position: relative;

        > .tip {
            position: absolute;
            top: 0;
            left: 170px;
            right: 0;
            bottom: 0;
            z-index: 1;
            text-align: left;
            padding-top: 16%;
            color: @primary-light-color;

            p {
                line-height: 18px;
                margin-bottom: 18px;

                &.tip {
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                }
            }

            h3 {
                font-size: 30px;
                margin-bottom: 18px;
                line-height: 48px;
                font-family: NotoSansKR-Bold, Helvetica, Arial, sans-serif;
            }

            .text {
                max-width: 450px;
                line-height: 27px;
                margin-bottom: 24px;
            }
        }
    }

    .carousel {
        /deep/ .carousel-item {
            //padding-bottom: 40.5% !important;
        }

        /deep/ .carousel-caption {
            left: @page-padding * 2.5;
            right: @page-padding * 2.5;
            text-align: left;

            .text {
                margin: 0 auto 36px 0;
            }

            .btn {
                margin-bottom: 76px;
            }
        }
    }

    .product-list {
        /deep/ .list {
            .title {
                padding-top: 60px !important;
            }
        }
    }
</style>
